import '../../css/base.css';

const Parking = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Parking</h2>
      <p className="your-stay-text">Space for one car in area opposite cottage. Space for one car to the right hand side of
                                    the cottage on the grass. Please be aware that very
                                    occasionally the land to the side of the cottage is used for camping. There
                                    are plenty of alternative places to park throughout the village if this is the
                                    case during your visit. 
      </p>                                            
    </div>
  );
}

export default Parking;